import { injectable } from 'inversify'

export type ExampleLoggerType = 'NULL' | 'CONSOLE'
export interface ExampleLogger {
  log(msg: string): void
}

@injectable()
export class NullLoggerExample implements ExampleLogger {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  log(msg: string): void {
    console.log('Nothing is logged')
  }
}
@injectable()
export class ConsoleLoggerExample implements ExampleLogger {
  log(msg: string): void {
    console.log(msg)
  }
}

//  DON'T DELETE - used by DW
